import './Sap.css';
import logoSap from '../../assets/images/sap/logo-sap.webp';

const Sap = () => {
  const badges = [
    'Entretien régulier',
    'Tonte de pelouse',
    'Taille de haies et arbustes',
    'Désherbage',
    'Débroussaillage',
    'Taille de petits arbres et fruitiers',
    'Évacuation des déchets verts',
  ];

  const steps = [
    {
      number: '1',
      title: 'Je réalise la prestation',
      text: 'Tonte, taille, désherbage... je m\'occupe de tout avec le même sérieux, qu\'il s\'agisse d\'un passage ponctuel ou d\'un entretien régulier.',
    },
    {
      number: '2',
      title: 'Vous recevez une attestation fiscale',
      text: 'Chaque année, je vous transmets automatiquement votre attestation fiscale. Aucune démarche de votre part.',
    },
    {
      number: '3',
      title: 'L\'État vous rembourse 50 %',
      text: 'Vous déclarez vos dépenses de jardinage sur votre déclaration de revenus. Le crédit d\'impôt est déduit directement de vos impôts — ou remboursé si vous n\'en payez pas.',
    },
  ];

  return (
    <section id="sap" className="sap-section">

      {/* Bloc principal : carte + texte */}
      <div className="sap-hero">

        <div className="sap-card">
          <div className="sap-card-header">
            <div className="sap-card-percentage">50 %</div>
            <div className="sap-card-label">de crédit d'impôt</div>
            <p className="sap-card-desc">
              Pour chaque prestation de jardinage, l'État vous rembourse la moitié de la facture —
              directement déduit de vos impôts, ou versé en remboursement si vous n'en payez pas.
            </p>
          </div>

          <div className="sap-card-body">
            <p className="sap-example-title">Exemple concret</p>
            <div className="sap-example-row">
              <span>Prestation facturée</span>
              <span>150 €</span>
            </div>
            <div className="sap-example-row credit">
              <span>Crédit d'impôt (50 %)</span>
              <span>− 75 €</span>
            </div>
            <div className="sap-example-row total">
              <span>Votre coût réel</span>
              <span>75 €</span>
            </div>
            <p className="sap-example-note">
              Valable que vous soyez imposable ou non — le remboursement est garanti dans tous les cas.
            </p>
          </div>
        </div>

        <div className="sap-hero-text">
          <h2 className="sap-script-title">Votre jardin à moitié prix</h2>
          <p>
            Pochard Espaces Verts est une entreprise agréée <strong>Services à la Personne</strong>. Toutes vos
            prestations d'entretien de jardin ouvrent droit à un <strong>crédit d'impôt de 50 %</strong>,
            que vous soyez imposable ou non. Ce dispositif est <strong>gratuit</strong> et entièrement{' '}
            <strong>optionnel</strong> — vous choisissez librement d'en bénéficier.
          </p>

          <p className="sap-badges-label">Prestations éligibles</p>
          <div className="sap-badges">
            {badges.map((badge) => (
              <span key={badge} className="sap-badge">{badge}</span>
            ))}
          </div>

          <img src={logoSap} alt="Agrément Services à la Personne" className="sap-logo-img" />
        </div>
      </div>

      {/* Étapes */}
      <div className="sap-steps-section">
        <div className="sap-steps-inner">
          <h2 className="sap-script-title">Comment ça fonctionne ?</h2>
          <div className="sap-steps-grid">
            {steps.map((step) => (
              <div key={step.number} className="sap-step">
                <div className="sap-step-header">
                  <div className="sap-step-number">{step.number}</div>
                  <h4>{step.title}</h4>
                </div>
                <p>{step.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

    </section>
  );
};

export default Sap;
